import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Tennis = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="tennis"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M54.9258 21.3137C55.3571 16.5692 53.8986 12.2604 50.8191 9.18087C47.7395 6.10136 43.4303 4.64291 38.6863 5.07424C34.0418 5.4965 29.5223 7.69058 25.9606 11.2524C22.3988 14.8142 20.2048 19.3336 19.7825 23.978C19.6525 25.4081 19.6954 26.7982 19.9013 28.1273L16.6384 37.3488C16.45 37.8811 16.5843 38.474 16.9835 38.8732L21.1267 43.0163C21.4061 43.2958 21.7806 43.4454 22.1626 43.4454C22.3264 43.4454 22.4914 43.4179 22.651 43.3615L31.8718 40.099C32.6937 40.2264 33.5388 40.2917 34.4026 40.2917C34.9358 40.2917 35.476 40.2671 36.0219 40.2175C40.6664 39.7953 45.1858 37.6012 48.7475 34.0394C52.3094 30.4776 54.5035 25.9581 54.9258 21.3137ZM51.7901 22.5811L50.8191 21.6101L52.0531 20.3762C52.0199 21.1054 51.9326 21.8426 51.7901 22.5811ZM51.7014 16.5848L48.7476 19.5386L45.6403 16.4313L49.7127 12.3588C50.6678 13.614 51.3281 15.0484 51.7014 16.5848ZM46.6761 21.6101L42.5329 25.7533L39.4256 22.6459L43.5687 18.5028L46.6761 21.6101ZM43.4155 8.29827C44.952 8.6717 46.3868 9.33145 47.642 10.2866L43.5687 14.3598L40.4614 11.2525L43.4155 8.29827ZM41.4972 16.4313L37.3541 20.5744L34.2467 17.4671L38.3899 13.3239L41.4972 16.4313ZM28.0322 23.6817L32.1753 19.5386L35.2826 22.6459L31.1395 26.7891L28.0322 23.6817ZM29.068 28.8606L24.9955 32.9331C24.0404 31.6779 23.3801 30.2436 23.0067 28.7072L25.9605 25.7534L29.068 28.8606ZM39.6234 7.94731L38.3899 9.18097L37.4195 8.21058C38.1577 8.0682 38.8945 7.98051 39.6234 7.94731ZM34.2315 9.16554L36.3184 11.2524L32.1752 15.3955L29.1065 12.3269C30.6965 10.9562 32.4382 9.89921 34.2315 9.16554ZM27.0353 14.3987L30.1038 17.4671L25.9606 21.6102L23.8732 19.5228C24.6068 17.7297 25.6648 15.9885 27.0353 14.3987ZM22.9181 22.7108L23.8891 23.6817L22.6552 24.9157C22.6884 24.1863 22.7757 23.4492 22.9181 22.7108ZM22.5449 40.2915L19.7085 37.4551L21.3893 32.7046C22.0416 33.9538 22.8771 35.0991 23.889 36.111C24.9007 37.1227 26.0452 37.9589 27.294 38.6111L22.5449 40.2915ZM31.293 36.9933C29.7565 36.62 28.3222 35.9596 27.067 35.0045L31.1395 30.932L34.2468 34.0394L31.293 36.9933ZM33.211 28.8606L37.3542 24.7175L40.4615 27.8248L36.3184 31.9679L33.211 28.8606ZM35.0844 37.3448L36.3184 36.1109L37.2893 37.0819C36.5509 37.2243 35.8138 37.3117 35.0844 37.3448ZM40.4773 36.1268L38.3899 34.0394L42.533 29.8962L45.6015 32.9646C44.0116 34.3352 42.2704 35.3932 40.4773 36.1268ZM44.6046 27.8248L48.7477 23.6816L50.8351 25.7691C50.1015 27.5622 49.0435 29.3034 47.673 30.8932L44.6046 27.8248Z"
          fill={fill}
        />
        <path
          d="M49.6277 55.0002C52.5939 55.0002 54.9986 52.5956 54.9986 49.6293C54.9986 46.663 52.5939 44.2583 49.6277 44.2583C46.6614 44.2583 44.2567 46.663 44.2567 49.6293C44.2567 52.5956 46.6614 55.0002 49.6277 55.0002Z"
          fill={fill}
        />
        <path
          d="M5.57208 50.2849C4.80931 51.0476 4.80931 52.2843 5.57208 53.047L6.9531 54.428C7.71587 55.1907 8.95246 55.1907 9.71513 54.428L14.9122 49.2309L10.7691 45.0879L5.57208 50.2849Z"
          fill={fill}
        />
        <path d="M12.8357 43.0137L14.9069 40.9424L19.0494 45.0849L16.9782 47.1561L12.8357 43.0137Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="50" height="50" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

Tennis.defaultProps = {
  className: null,
};

Tennis.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Tennis;
